var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('router-view')],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d4ea5f6e","hasScoped":false,"optionsId":"0","buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/Adm/CPD/containers/CPD.vue
// module id = null
// module chunks = 